(() => {
  const root = document.querySelector('product-info[id^="MainProduct-"]');
  if (!root) return;

  const bar = root.querySelector('.ph-mobile-bar');
  if (!bar) return;
  const action = bar.querySelector('.ph-mobile-bar__button');
  const details = bar.querySelector('.ph-mobile-bar__name');
  const price = bar.querySelector('.ph-mobile-bar__price');
  const sectionId = root.dataset.section;
  const selectedByUser = new Set();
  const initialVariant = new URLSearchParams(window.location.search).has('variant');
  let mainButtonVisible = true;
  let pending = false;

  const picker = () => root.querySelector('variant-selects');
  const form = () => root.querySelector(`#product-form-${sectionId}`);
  const mainButton = () => root.querySelector(`#ProductSubmitButton-${sectionId}`);
  const selectedVariant = () => {
    try { return JSON.parse(picker()?.querySelector('[data-selected-variant]')?.textContent || 'null'); }
    catch { return null; }
  };
  const selectedOptions = () => Array.from(picker()?.querySelectorAll('fieldset') || []).map((fieldset) => {
    const control = fieldset.querySelector('input:checked');
    return { name: fieldset.querySelector('legend')?.textContent?.trim() || '', value: control?.value || '', display: control?.dataset.sizeDisplay || '', position: control?.dataset.optionValueId || '' };
  });
  const consentVisible = () => Array.from(document.querySelectorAll('#shopify-pc__banner, [id^="shopify-pc__banner"], .shopify-pc__banner__dialog')).some((node) => {
    const box = node.getBoundingClientRect();
    return box.height > 20 && getComputedStyle(node).visibility !== 'hidden' && getComputedStyle(node).display !== 'none';
  });
  const currentPrice = () => {
    const container = root.querySelector(`#price-${sectionId}`);
    const priceElement = container?.querySelector('.price--on-sale .price__sale .price-item--sale') || container?.querySelector('.price__regular .price-item--regular');
    return priceElement?.textContent?.trim() || '';
  };
  const optionGroups = () => Array.from(picker()?.querySelectorAll('fieldset') || []);
  const explicitlyChosen = () => initialVariant || optionGroups().every((group) => {
    const input = group.querySelector('input:checked');
    return input && selectedByUser.has(input.name);
  });
  const selectionMatches = (variant) => {
    const id = form()?.querySelector('input[name="id"]')?.value;
    if (!variant || !id || String(variant.id) !== id) return false;
    const options = selectedOptions();
    return options.length > 0 && options.every((option, index) => option.value === variant.options?.[index]);
  };
  const update = () => {
    const variant = selectedVariant();
    const options = selectedOptions();
    const chosen = explicitlyChosen();
    const ready = chosen && !pending && selectionMatches(variant) && variant.available && !mainButton()?.disabled;
    const sizeOption = options.find((option) => /size/i.test(option.name));
    const size = sizeOption?.display || sizeOption?.value?.split('/')[0]?.trim();
    const colour = options.find((option) => /colou?r/i.test(option.name))?.value;
    const nextDetails = [size, colour].filter(Boolean).join(' · ') || 'Choose your print';
    const nextPrice = !pending && variant && selectionMatches(variant) ? currentPrice() : '';
    const nextAction = ready ? 'Add to basket' : variant && chosen && !pending && !variant.available ? 'Unavailable' : 'Choose options';
    if (details.textContent !== nextDetails) details.textContent = nextDetails;
    if (price.textContent !== nextPrice) price.textContent = nextPrice;
    if (action.textContent !== nextAction) action.textContent = nextAction;
    action.disabled = false;
    action.dataset.ready = String(Boolean(ready));
    const visible = matchMedia('(max-width: 749px)').matches && !mainButtonVisible && !consentVisible();
    bar.classList.toggle('is-visible', visible);
    document.body.classList.toggle('ph-mobile-bar-active', visible);
  };
  const focusPicker = () => {
    const target = picker();
    target?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    target?.querySelector('input:not(.disabled), select')?.focus({ preventScroll: true });
  };

  action.addEventListener('click', () => {
    update();
    if (action.dataset.ready !== 'true') { focusPicker(); return; }
    const variant = selectedVariant();
    if (!selectionMatches(variant) || pending || mainButton()?.disabled) { focusPicker(); return; }
    mainButton().click();
  });
  root.addEventListener('click', (event) => {
    const option = event.target.closest('variant-selects input[type="radio"]');
    if (!option) return;
    selectedByUser.add(option.name);
    queueMicrotask(update);
  });
  root.addEventListener('change', (event) => {
    if (!event.target.closest('variant-selects')) return;
    if (event.target.name) selectedByUser.add(event.target.name);
    pending = true;
    update();
  });
  const observer = new IntersectionObserver(([entry]) => {
    mainButtonVisible = entry.isIntersecting;
    update();
  }, { threshold: 0.01 });
  if (mainButton()) observer.observe(mainButton());
  const mutation = new MutationObserver(update);
  mutation.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
  window.addEventListener('pageshow', update);
  window.addEventListener('resize', update);
  root.addEventListener('ph:size-unit-change', update);
  document.addEventListener('shopify:section:load', update);
  if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof subscribe === 'function') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      if (data.sectionId !== sectionId) return;
      pending = false;
      update();
    });
  }
  update();
})();
